<div *ngIf="loading; else show_them">
  <br />Loading...
</div>
<ng-template #show_them>
  <button class="nav" (click)="toggleShowAll()" style="margin-left: 0.2em">
    <ng-container *ngIf="showAll; else notall">Hide Empty Responses</ng-container>
    <ng-template #notall>Show All Responses</ng-template>
  </button>
  <button class="nav" (click)="downloadAsCSV()" style="margin-left: 1.2em">
    Download Responses as CSV
  </button>
  <div class="responses_header">
    <span class="actions">
      <ng-container *ngIf="!!before && !!beforeResponses && beforeResponses.length; else space">
        <button (click)="later()" class="nav">Newer</button>
      </ng-container>
      <ng-template #space> &nbsp; </ng-template>
    </span>
    <span class="received">Received</span>
    <span class="name">From</span>
    <span class="duration">Secs</span>
    <span class="contact">Contact details</span>
  </div>
  <div *ngIf="responses && responses.length > 0; else empty" id="responses">
    <div *ngFor="let response of responses"
         [style.background-color]="this.getColorFor(response)"
         (click)="onSelect(response)"
         class="response">
      <div class="actions">
        <span class="image_button_container">
          <a
            href="/api/private/r/audio/{{response.id}}/m4a/{{response.topic}}-{{response.id}}-{{response.name}}.m4a"
            download="{{response.topic}}-{{response.id}}-{{response.name}}.m4a"
            target="_blank">
            <img src="/images/download.svg" class="image_button_small" title="Download">
          </a>
        </span>
        <span class="image_button_container">
          <img src="/images/play.svg" class="image_button_small" title="Open Player" (click)="onSelect(response)">
        </span>
        <div *ngIf="response.published; else unpublished" id="published">
          <span class="image_button_container">
            <img src="/images/published.svg" class="image_button_small" title="Publish" (click)="publishResponse(response)">
          </span>
        </div>
        <ng-template #unpublished>
          <span class="image_button_container">
            <img src="/images/publish.svg" class="image_button_small" title="Publish" (click)="publishResponse(response)">
          </span>
        </ng-template>
        <span class="image_button_container">
          <img src="/images/user.svg" class="image_button_small" title="Show this person's responses" (click)="personResponses(response)">
        </span>
      </div>
      <span (click)="onSelect(response)">
        <span class="received"><span class="date"> {{response.received | smalltime}} </span></span>
        <span class="name"> {{response.name}} <span *ngIf="!!response.location"> from {{response.location}} </span></span>
        <span class="duration"> {{response.duration | secs}} </span>
        <span class="contact" *ngIf="!!response.email || !!response.phone">
          <span *ngIf="!!response.email"> <a href="mailto:{{response.email}}">{{response.email}}</a> </span>
          <span *ngIf="!!response.email && !!response.phone">, </span>
          <span *ngIf="!!response.phone"> <a href="tel:{{response.phone}}">{{response.phone}}</a> </span>
        </span>
        <div *ngIf="!topic_id">
          <span class="transcript"> {{response.topic_short_name}}: </span>
        </div>
        <span class="transcript">
          <ng-container *ngIf="!!response.corrected_transcript; else original">{{response.corrected_transcript}}</ng-container>
          <ng-template #original>{{response.transcript}}</ng-template>
        </span>
      </span>
    </div>
  </div>
  <ng-template #empty> &nbsp; <br />No responses in range.<br /> &nbsp; </ng-template>
  <div class="responses_header">
    <span class="actions"><button (click)="earlier()" class="nav">Older</button></span>
  </div>
  <div> &nbsp; <br /> &nbsp; <br /> &nbsp; </div>
  <div *ngIf="currentResponse" id="currentResponsePlayer" class="player">
    <response-player [response]="currentResponse"
                     (responseChange)="responseUpdated($event)"
                     [observableResponse]="currentResponseObservable"
                     (cancelPlayer)="cancelPlayer($event)"></response-player>
  </div>
</ng-template>